import styles from '../../../MultiStepPMSLogin.module.scss'
import auth1 from './auth1.png'
import auth2 from './auth2.png'
import auth3 from './auth3.png'
import auth4 from './auth4.png'
import auth5 from './auth5.png'
import auth6 from './auth6.png'
import auth7 from './auth7.png'
import auth8 from './auth8.png'
import auth9 from './auth9.png'

const DualFactorAuth = () => {
  return (
    <div className={styles.solutionContainer}>
      <p className={styles.descriptionTextEmp}>
        Please access to https://extranetcloud.marriott.com/ and switch to the two-step
        registration portal.Then click on "New User Registration" button.
      </p>
      <img src={auth1} alt="auth1" />
      <p className={styles.descriptionTextEmp}>
        Check your user information from User Profile of the portal.
      </p>
      <img src={auth2} alt="auth2" />
      <p className={styles.descriptionTextEmp}>User information should be like below</p>
      <img src={auth3} alt="auth3" />
      <p className={styles.descriptionTextEmp}>
        Fill the email fields given correctly on Email Registration step.
      </p>
      <img src={auth4} alt="auth4" />
      <p className={styles.descriptionTextEmp}>Select additional user information.</p>
      <img src={auth5} alt="auth5" />
      <p className={styles.descriptionTextEmp}>Set your preference.</p>
      <img src={auth6} alt="auth6" />
      <p className={styles.descriptionTextEmp}>Validate your phone number.</p>
      <img src={auth7} alt="auth7" />
      <p className={styles.descriptionTextEmp}>
        After validation, click on the "submit" button in order to submit the number.
      </p>
      <img src={auth8} alt="auth8" />
      <p className={styles.descriptionTextEmp}>
        If the process is succeeded, you should see a success message as below.
      </p>
      <img src={auth9} alt="auth9" />
    </div>
  )
}

export default DualFactorAuth
